import { render } from "./TriggerAndConditionLightDimmer.vue?vue&type=template&id=652a5560&ts=true"
import script from "./TriggerAndConditionLightDimmer.ts?vue&type=script&lang=ts"
export * from "./TriggerAndConditionLightDimmer.ts?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__